import { Enum } from "typescript-string-enums";

const actionTypes = Enum(
  'ADD_FAMILY_SHARING',
  'CANCEL_PAYMENT',
  'CHECK_CODE',
  'CHECK_DUPLICATE_AND_QUARANTINE',
  'CLEAR_SPID_TOKEN',
  'CREATE_ORDER',
  'CREATE_SPID_USER',
  'FETCH_CUSTOMERSERVICE_INFO',
  'FETCH_BRREG_INFO',
  'SET_BRREG_INFO',
  'SET_BRREG_INPUT',
  'FETCH_USER_INFO',
  'FIND_USER_BY_EMAIL',
  'FIND_USER_BY_PHONE_NUMBER',
  'HIDE_TIMEOUT',
  'SEND_LOGIN_LINK',
  'SEND_SMS',
  'SET_ALTERNATE_OFFER_PRODUCT',
  'SET_FULL_PRICE_PRODUCT',
  'SET_PRODUCT',
  'SET_PRODUCT_QUARANTINED',
  'SET_REDIRECT_URI',
  'SET_REFERER',
  'SET_SELECTED_PAYMENT_METHOD',
  'SET_SESSION_INFO',
  'SET_SIG_AND_SPIDID_FROM_URL',
  'SET_UPSALE_PRODUCT_INFO',
  'SET_UTM_SOURCE',
  'SET_UTM_MEDIUM',
  'SET_UTM_CAMPAIGN',
  'SET_UTM_TERM',
  'SET_UTM_CONTENT',
  'SHOW_TIMEOUT',
  'USER_ENTERS_APARTMENT_NUMBER',
  'USER_ENTERS_BIRTH_DAY',
  'USER_ENTERS_BIRTH_MONTH',
  'USER_ENTERS_BIRTH_YEAR',
  'USER_ENTERS_CITY',
  'USER_ENTERS_CODE',
  'USER_ENTERS_DELIVERY_POINT_ID',
  'USER_ENTERS_EMAIL',
  'USER_ENTERS_ENTRANCE',
  'USER_ENTERS_FIRST_NAME',
  'USER_ENTERS_FLOOR',
  'USER_ENTERS_HOUSE_NUMBER',
  'USER_ENTERS_LAST_NAME',
  'USER_ENTERS_PHONE_NUMBER',
  'USER_ENTERS_CO_ADDRESS',
  'USER_ENTERS_STREET_ADDRESS',
  'USER_ENTERS_ZIPCODE',
  'USER_ENTERS_LOYALTY_CODE',
  'VALIDATE_LOYALTY_CODE',
  'SET_PAYEX_URL'
);
export type ActionTypes = keyof typeof actionTypes;

export default actionTypes;
